export const defaultMemberSignInFormData = {
    username: '',
    email: '',
    password: '',
    captcha: undefined,
    remember: false
};
//# sourceMappingURL=data.js.map